import axios from "axios";

//example data
// event: {
//     "username": "",
//     "password": "",
//     "email": "",
//     "custom:firstname": "",
//     "custom:lastname": "",
//     "custom:tenantName": "",
//     "userpoolid": ""
//     "action": "update" or nothing
//   }
export function createCognitoUserWs(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/createCognitoUser`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

//example data
// event {
//     "username": "",
//     "action": "",
//     "userpoolid": ""
//   }
//actions: (enable/disable/delete/resetpassword)
export function userManagementWs(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/manageCognitoUser`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}
